import getService from 'src/core/services/base'
import apiKey from 'src/core/services/base/apiKey'

// type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { OrderOtherResponse, OthersOrder, DropsOrder } from './model'

const url = '/order/product' as const

/**
 * W06-02 查詢會員購物車內容(其他商品)
 */
export function getOrderOthers(params: { language: string }, openUnAutoToast?: () => void) {
  return getService<OrderOtherResponse>(
    {
      config: {
        url,
        method: 'get',
        params,
      },
      name: apiKey.getOrderOthers,
    },
    openUnAutoToast,
  ).then((res) => {
    const resultData = res.data.result_data
    if (!resultData.length) return undefined

    const result = resultData.reduce(
      (obj, item) => {
        if (!item.order_infos) return obj

        if ('buy_type' in item) {
          obj.drops = item
        } else {
          obj.others = {
            ...item,
            order_infos: item.order_infos.reduce((pre, info) => {
              pre[info.sub_type_no] = info

              return pre
            }, {} as Record<string, OthersOrder['order_infos'][number]>),
          }
        }

        return obj
      },
      { drops: null, others: null } as {
        drops: DropsOrder | null
        others: (Omit<OthersOrder, 'order_infos'> & { order_infos: Record<string, OthersOrder['order_infos'][number]> }) | null
      },
    )

    return result
  })
}
